// extracted by mini-css-extract-plugin
export default {"link":"TermsOfUseLink_link__ACfKC"};